import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots } from "vue"

import { useForm } from '@inertiajs/vue3';
    import ProcedureForm from './ProcedureForm.vue';
    import DialogForm from '@/components/DialogForm.vue';
    import QueryKey from '@/enums/QueryKey';
    import type { Procedure } from '@/types';
    import { Button } from '@/components/ui/button';
    import { DialogFooter, DialogClose } from '@/components/ui/dialog';
    import { useI18n } from 'vue-i18n';
    import Permission from '@/enums/Permission';
    import { usePermissions } from '@/composables/usePermissions';
    import { usePage } from '@inertiajs/vue3';
    import { computed, ref } from 'vue';
    import type { SharedData } from '@/types';
    import DeleteProcedure from './DeleteProcedure.vue';
    import ContinueButton from '@/components/ContinueButton.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EditProcedure',
  props: {
    procedure: {}
  },
  setup(__props: any) {

    const props = __props;

    const { t } = useI18n();
    const { hasPermission } = usePermissions();

    const page = usePage<SharedData>();
    const isClient = computed(() => page.props.auth.user.is_client);

    const form = useForm({
        procedure_id: props.procedure.procedure_id,
        company_id: props.procedure.company_id,
        procedure_task: props.procedure.procedure_task,
        procedure_responsible: props.procedure.procedure_responsible_ids,
        procedure_deadline: props.procedure.procedure_deadline,
    });

    const dialogFormRef = ref<InstanceType<typeof DialogForm>>();

    const handleDelete = () => {
        dialogFormRef.value?.invalidateQueryAndClose();
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    ref_key: "dialogFormRef",
    ref: dialogFormRef,
    type: "update",
    method: "post",
    form: _unref(form),
    route: _ctx.route('v2.dashboard.procedures.update'),
    "query-key": [_unref(QueryKey).DASHBOARD_PROCEDURES, props.procedure.company_id],
    title: "dashboards.procedures_edit"
  }, _createSlots({
    footer: _withCtx(() => [
      _createVNode(_unref(DialogFooter), { class: "gap-2 border-t sm:justify-center" }, {
        default: _withCtx(() => [
          (_unref(hasPermission)(_unref(Permission).DASHBOARD_ADMIN_DELETE))
            ? (_openBlock(), _createBlock(DeleteProcedure, {
                key: 0,
                procedure: _ctx.procedure,
                onDeleted: handleDelete
              }, null, 8, ["procedure"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(DialogClose), { "as-child": "" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                variant: "outline",
                size: "sm",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(form).resetAndClearErrors()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('forms.cancel')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_unref(hasPermission)(_unref(Permission).DASHBOARD_ADMIN_CREATE))
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 1,
                disabled: _unref(form).processing,
                loading: _unref(form).processing,
                size: "sm",
                variant: "default"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('button-text.save')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "loading"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(ProcedureForm, { form: _unref(form) }, null, 8, ["form"])
    ]),
    _: 2
  }, [
    (isClient.value)
      ? {
          name: "trigger",
          fn: _withCtx(() => [
            _createVNode(ContinueButton, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('forms.open')), 1)
              ]),
              _: 1
            })
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["form", "route", "query-key"]))
}
}

})